import { ChatContainer } from "../components/chat";

export function ChatPage() {
  return <ChatContainer />;
}
